import { styled } from 'buttered';

export let HR = styled('hr')`
  background: #ddd;
  height: 1px;
  border: none;
`;
